/* eslint-disable no-unused-vars */
import Cookies from 'js-cookie';

import { getStoreCookiePath } from 'store/common/settings/selectors';
import { FOLLOW_LINK, ORIGIN_COOKIE_NAME } from 'store/constants';

const setOriginSourceInCookie = (payload, path) => {
  /** change cookie value */
  Cookies.set(ORIGIN_COOKIE_NAME, payload, { expires: 365, path });
};

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const state = getState();
    const path = getStoreCookiePath(state);
    const { type, payload } = action;

    switch (type) {
      case FOLLOW_LINK:
        setOriginSourceInCookie(payload, path);
        break;
      default:
        break;
    }
    return next(action);
  };
